import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { UserEditPage } from '@/features/users/pages/UserEditPage';

const searchSchema = z.object({
  userId: z.number(),
  from: z.string().optional(),
});

export const Route = createFileRoute('/_auth/users/edit')({
  validateSearch: searchSchema,
  component: function UserEditRoute() {
    const { userId, from } = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Edit User">
        <UserEditPage userId={userId} fallbackPath={from} />
      </ErrorBoundary>
    );
  },
});
